module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n            " + _vm._s(_vm.marking.markingCode) + "\n        ")]), _vm._v(" "), _c('template', {
    slot: "extra"
  }, [_vm._v("\n            " + _vm._s(_vm.marking.marketingCode) + "  \n            "), _c('Tag', {
    attrs: {
      "color": "green"
    }
  }, [_vm._v(_vm._s(_vm.marking.totalReceivableRemaining) + " ")])], 1), _vm._v(" "), _vm._l((_vm.invoicesFormatted), function(invoice, idx) {
    return _c('div', {
      key: idx
    }, [_c('cInvoiceUnSettledByMarkingRow', {
      attrs: {
        "invoice": invoice
      }
    })], 1)
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14274faf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/cInvoiceUnSettledByMarking.vue
// module id = 1779
// module chunks = 1